export default __webpack_public_path__ + "static/media/button_kikan-DAY.2852333c.PNG";